/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CopilotMetrics extends models.CopilotLinesOfCodeSummaryBase {
    getFixupPrototypeFunction() { return CopilotMetrics.fixupPrototype; }

    static newInstance(model: Partial<CopilotMetrics>): CopilotMetrics {
        let obj = Object.assign(new CopilotMetrics(), model);
        CopilotMetrics.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CopilotMetrics>): CopilotMetrics {
        if (!model) return null;
        return CopilotMetrics.newInstance(<CopilotMetrics> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CopilotMetrics) {
        if (!obj) return;

        models.CopilotMetrics.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CopilotMetrics): boolean {
        if (models.CopilotLinesOfCodeSummaryBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CopilotMetrics.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.feature_metrics) {
            for (let val of this.feature_metrics) {
                models.CopilotFeatureMetric.fixupPrototype(val);
            }
        }
        if (this.ide_metrics) {
            for (let val of this.ide_metrics) {
                models.CopilotIdeMetric.fixupPrototype(val);
            }
        }
        if (this.language_feature_metrics) {
            for (let val of this.language_feature_metrics) {
                models.CopilotLanguageFeatureMetric.fixupPrototype(val);
            }
        }
        if (this.language_metrics) {
            for (let val of this.language_metrics) {
                models.CopilotLanguageMetric.fixupPrototype(val);
            }
        }
        if (this.language_model_metrics) {
            for (let val of this.language_model_metrics) {
                models.CopilotLanguageModelMetric.fixupPrototype(val);
            }
        }
        if (this.model_feature_metrics) {
            for (let val of this.model_feature_metrics) {
                models.CopilotModelFeatureMetric.fixupPrototype(val);
            }
        }
    }

    /**
     * Activity metrics broken down by feature
     */
    feature_metrics: Array<models.CopilotFeatureMetric>;

    /**
     * Activity metrics broken down by IDE
     */
    ide_metrics: Array<models.CopilotIdeMetric>;

    /**
     * Activity metrics broken down by language and feature
     */
    language_feature_metrics: Array<models.CopilotLanguageFeatureMetric>;

    /**
     * Activity metrics broken down by programming language
     */
    language_metrics: Array<models.CopilotLanguageMetric>;

    /**
     * Activity metrics broken down by programming language and AI model
     */
    language_model_metrics: Array<models.CopilotLanguageModelMetric>;

    /**
     * Activity metrics broken down by model and feature
     */
    model_feature_metrics: Array<models.CopilotModelFeatureMetric>;

    /**
     * Service account the metrics belong to
     */
    service_account_id: string;

    /**
     * CoreStack internal user ID
     */
    user_id: string;

}
